// src/config/apiConfig.js
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
export const FRONT_URL = process.env.REACT_APP_FRONT_URL || "http://localhost:3000";